import React, { useEffect, useState, useRef, useMemo } from "react";
import { Icon } from "@iconify/react";
import Swal from "sweetalert2";
import api from "../../../utils/axios";
import { getData } from "../../../utils/SamuiUtils";
import FileModalLocation from "../Modal/FileModalAppointment";
import ServiceLocationModal from "../Modal/LocationModal";
import { MapContainer, TileLayer, Marker, Popup, useMap, Polyline, CircleMarker } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import LocationModal from "../Modal/Quote/Admin/Service1stModal"

function TimePickerHybrid({ value, onChange = () => {}, disabled = false }) {
  const [time, setTime] = useState(value || "");
  const [open, setOpen] = useState(false);
  const pickerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => setTime(value || ""), [value]);

  const validateTime = (val) => /^([01]\d|2[0-3]):([0-5]\d)$/.test(val);

  const handleInput = (e) => {
    setTime(e.target.value);
  };

  const handleBlur = () => {
    let val = time?.trim() || "";
    val = val.replace(/[^\d:.]/g, "");
    if (/^\d{3,4}$/.test(val)) {
      const h = val.length === 3 ? "0" + val[0] : val.slice(0, 2);
      const m = val.slice(-2);
      val = `${h}:${m}`;
    } else if (/^\d{1,2}[.:]\d{1,2}$/.test(val)) {
      const [h, m] = val.split(/[.:]/).map((x) => x.padStart(2, "0"));
      val = `${h}:${m}`;
    }

    const isValid = validateTime(val);
    if (isValid) {
      setTime(val);
      onChange(val);
    } else {
      setTime("");
    }
  };

  const handleSelect = (h, m) => {
    const newVal = `${h.padStart(2, "0")}:${m.padStart(2, "0")}`;
    setTime(newVal);
    onChange(newVal);
    setOpen(false);
  };

  return (
    <div ref={pickerRef} className="relative">
      <div className="flex items-center">
        <input
          type="text"
          value={time}
          onChange={handleInput}
          onBlur={handleBlur}
          placeholder="ระบุเวลา"
          readOnly={disabled}
          className={`w-full border rounded px-3 py-2 h-[42px] font-mono ${
            disabled ? "bg-gray-100 cursor-not-allowed" : ""
          }`}
        />
        {!disabled && (
          <button
            type="button"
            onClick={() => setOpen(!open)}
            className="ml-2 text-gray-500 hover:text-gray-700"
          >
            <Icon icon="mdi:clock-outline" className="w-6 h-6" />
          </button>
        )}
      </div>

      {!disabled && open && (
        <div className="absolute mt-2 bg-white border rounded-lg shadow-lg p-3 z-50 flex gap-2">
          <select
            onChange={(e) =>
              handleSelect(e.target.value, time.split(":")[1] || "00")
            }
            value={time.split(":")[0] || "00"}
            className="border rounded px-2 py-1"
          >
            {Array.from({ length: 24 }, (_, i) => (
              <option key={i} value={i.toString().padStart(2, "0")}>
                {i.toString().padStart(2, "0")}
              </option>
            ))}
          </select>
          :
          <select
            onChange={(e) =>
              handleSelect(time.split(":")[0] || "00", e.target.value)
            }
            value={time.split(":")[1] || "00"}
            className="border rounded px-2 py-1"
          >
            {Array.from({ length: 60 }, (_, i) => (
              <option key={i} value={i.toString().padStart(2, "0")}>
                {i.toString().padStart(2, "0")}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
}

// =================== AppointmentModal ===================
export default function AppointmentModal({
  isOpen,
  onClose,
  onSave,
  customerData,
  serviceAddrId,
  initialData,
  appointLatitude,
  appointLongitude,
  selectedDate,
  buttonType,
  fromCustomerPage = false
}) {
  const [form, setForm] = useState({
    Purpose: initialData?.forcePurpose || initialData?.Purpose || "followup",
    Sale_Emp_Id: "",
    Appoint_Date: "",
    Time_Start: "",
    Time_End: "",
    Remark: "",
    Width: "",
    Length: "",
    Height: "",
    SpecRemark: "",
    Appoint_Id: null,
  });

  const [employees, setEmployees] = useState([]);
  const [showFileModal, setShowFileModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [latlng, setLatlng] = useState({ lat: null, lng: null });

  const [checkinPos, setCheckinPos] = useState({ lat: null, lng: null });
  const [serviceInfo, setServiceInfo] = useState(null);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [servicePurposes, setServicePurposes] = useState([]);
  const [showServiceModal, setShowServiceModal] = useState(false);
  const [showAddrPicker, setShowAddrPicker] = useState(false);
  const formRef = useRef(null);
  const cust = customerData || {};

  const contactName = cust.contact?.AR_ContactName || "-";
  const contactPhone = cust.contact?.AR_Tel || "-";

  useEffect(() => {
    if (!isOpen) return;
    
    // ใช้ ServiceAddr_Id จาก form หรือ initialData
    const addrId = form.ServiceAddr_Id || initialData?.ServiceAddr_Id || serviceAddrId;
    if (!addrId) return;
    
    const loadServiceInfo = async () => {
      try {
        const res = await api.get(`/get-tb-set-service-addr-by-id/${addrId}`);
        const data = res.data?.result?.recordset?.[0];
        if (data) {
          setLatlng({ lat: data.Latitude || null, lng: data.Longitude || null });
          setServiceInfo(data);
        }
      } catch (err) {
        console.error("โหลดข้อมูลสถานที่ไม่สำเร็จ:", err);
      }
    };
    loadServiceInfo();
  }, [isOpen, form.ServiceAddr_Id, initialData?.ServiceAddr_Id, serviceAddrId]);

  useEffect(() => {
    if (!isOpen) return;
    const fetchServiceTypes = async () => {
      try {
        const res = await getData(
          "Tb_Set_ServiceAddrType",
          "ServiceAddr_Type_Status = 'Y'"
        );
        const rows = Array.isArray(res) ? res : res?.data || [];
        const mapped = rows
          .map((item) => ({
            id: item?.ServiceAddr_Type_Id ?? item?.id ?? item?.Id,
            name:
              item?.ServiceAddr_Type_Name ??
              item?.name ??
              item?.ServiceAddr_Type,
          }))
          .filter((item) => item.id && item.name);
        setServiceTypes(mapped);
      } catch (err) {
        console.error("โหลดประเภทสถานที่บริการไม่สำเร็จ:", err);
        setServiceTypes([]);
      }
    };
    fetchServiceTypes();
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    const fetchServicePurposes = async () => {
      try {
        const res = await getData(
          "Tb_Set_ServicePurpose",
          "ServicePurpose_Status = 'Y'"
        );
        const rows = Array.isArray(res) ? res : res?.data || [];
        const mapped = rows
          .map((item) => ({
            id:
              item?.ServicePurpose_Id ??
              item?.ServicePurposeId ??
              item?.Purpose_Id ??
              item?.id ??
              item?.Id,
            name:
              item?.ServicePurpose_Name ??
              item?.Purpose_Name ??
              item?.name ??
              item?.ServicePurpose,
          }))
          .filter((item) => item.id && item.name);
        setServicePurposes(mapped);
      } catch (err) {
        console.error("โหลดวัตถุประสงค์ไม่สำเร็จ:", err);
        setServicePurposes([]);
      }
    };
    fetchServicePurposes();
  }, [isOpen]);

  const formatToThaiDate = (isoDate) => {
    if (!isoDate) return "";
    const [y, m, d] = isoDate.split("-");
    return `${d}/${m}/${parseInt(y) + 543}`;
  };

  useEffect(() => {
    const loadFiles = async () => {
      if (!isOpen || !form.Appoint_Id) return;
      try {
        const res = await api.get(`/get-appoint-files/${form.Appoint_Id}`);

        if (res.data.status === "OK" && Array.isArray(res.data.result?.recordset)) {
          const files = res.data.result.recordset.map((f) => ({
            File_Id: f.File_Id,
            File_Url: decodeURI(f.FilePath),
            File_Name: f.FileName,
            type: f.FileType || "",
            size: f.FileSize || 0,
          }));
          setSelectedFiles(files);
        }
      } catch (err) {
        console.error("โหลดไฟล์นัดหมายไม่สำเร็จ:", err);
      }
    };

    loadFiles();
  }, [isOpen, form.Appoint_Id]);

  useEffect(() => {
    if (!isOpen) return;
    api
      .get(`/get-employees/${customerData?.Comp_Id || 1}`)
      .then((res) => setEmployees(res.data?.result || []))
      .catch(() => setEmployees([]));
  }, [isOpen, customerData?.Comp_Id]);

  //  โหลดข้อมูลเวลาแก้ไข
  useEffect(() => {
  if (!isOpen) return;

  const empId = localStorage.getItem("emp_id");
  const today = new Date().toISOString().split("T")[0];

  // ถ้าเปิดแก้ไข → ใช้ purpose จาก initialData 100%
  if (initialData?.Appoint_Id) {
    setForm({
      Purpose: initialData.Purpose || "visit",
      Sale_Emp_Id: String(initialData.Sale_Emp_Id || empId || ""),
      Appoint_Date: initialData.Appoint_Date
        ? initialData.Appoint_Date.split("T")[0]
        : today,
      Time_Start: initialData.Time_Start || "",
      Time_End: initialData.Time_End || "",
      Remark: initialData.Appoint_Remark || initialData.Remark || "",
      Appoint_Id: initialData.Appoint_Id,
      Width: initialData.Width || "",
      Length: initialData.Length || "",
      Height: initialData.Height || "",
      SpecRemark: initialData.SpecRemark || "",
      ServiceAddr_Id: initialData.ServiceAddr_Id || serviceAddrId || null,
    });

    setCheckinPos({
      lat: initialData.Sale_Latitude || null,
      lng: initialData.Sale_Longitude || null,
    });
    return;
  }

  // ========== กรณีสร้างใหม่ ==========
  // กำหนดค่า purpose ตามลำดับความสำคัญ
  const purposeDefault =
    initialData?.forcePurpose ||
    initialData?.Purpose ||
    (buttonType === "appoint" ? "visit" : "followup");

  const resolvedAddr = initialData?.ServiceAddr_Id || serviceAddrId || null;

  setForm({
    Purpose: purposeDefault,
    Sale_Emp_Id: empId || "",
    Appoint_Date: selectedDate || today,
    Time_Start: "",
    Time_End: "",
    Remark: "",
    Width: "",
    Length: "",
    Height: "",
    SpecRemark: "",
    Appoint_Id: null,
    ServiceAddr_Id: resolvedAddr,
  });

  if (purposeDefault === "visit" && !resolvedAddr) {
    setShowAddrPicker(true);
  }
}, [isOpen]);


  useEffect(() => {
    if (!isOpen) return;
    if (appointLatitude || appointLongitude) {
      setCheckinPos({
        lat: appointLatitude,
        lng: appointLongitude,
      });
    }
  }, [isOpen, appointLatitude, appointLongitude]);

  function MapUpdater({ lat, lng }) {
    const map = useMap();
    useEffect(() => {
      if (lat && lng && !isNaN(lat) && !isNaN(lng)) {
        map.setView([parseFloat(lat), parseFloat(lng)], map.getZoom());
      }
    }, [lat, lng, map]);
    return null;
  }

  // Move useMemo before early return to maintain consistent hook order
  const purposeMap = useMemo(() => {
    const map = new Map();
    servicePurposes.forEach((item) => {
      map.set(String(item.id), item.name);
    });
    return map;
  }, [servicePurposes]);

  const purposeLabel = (code) =>
    purposeMap.get(String(code)) || "-";

  if (!isOpen) return null;

  const handleStartChange = (val) => {
    let [h, m] = val.split(":").map(Number);
    h = (h + 1) % 24;
    const endTime = `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}`;
    setForm({ ...form, Time_Start: val, Time_End: endTime });
  };

  function getDistanceKm(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const toRad = (d) => (d * Math.PI) / 180;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) ** 2;
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  const validateTimeOrder = (start, end) => {
    if (!start || !end) return true;
    const [sh, sm] = start.split(":").map(Number);
    const [eh, em] = end.split(":").map(Number);
    return eh * 60 + em > sh * 60 + sm;
  };

  const getCurrentPosition = () => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error("เบราว์เซอร์นี้ไม่รองรับ GPS"));
        return;
      }
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          resolve({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          });
        },
        reject,
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
      );
    });
  };

  const handleSaveServiceLocation = async (formData) => {
    try {
      const payload = {
        ...formData,
        Update_By_Name: localStorage.getItem("name") || "System",
        Update_By_Id: localStorage.getItem("emp_id") || 0,
      };

      const res = await api.put(
        `/update-tb-set-service-addr/${formData.ServiceAddr_Id}`,
        payload
      );

      if (res.data.status === "OK") {
        setShowServiceModal(false);

        return {
          status: "OK",
          ServiceAddr_Id: formData.ServiceAddr_Id,
        };
      } else {
        Swal.fire("ผิดพลาด", res.data.message || "อัปเดตไม่สำเร็จ", "error");
        return {
          status: "FAILED",
          message: res.data.message,
        };
      }

    } catch (err) {
      Swal.fire("ผิดพลาด", "ไม่สามารถอัปเดตสถานที่บริการได้", "error");
      return {
        status: "FAILED",
        error: err.message,
      };
    }
  };

  const userRole = localStorage.getItem("role");

  const formatTime = (iso) => {
    if (!iso) return "-";
    if (iso.includes("T")) {
      return iso.substring(11, 16); // ตัดได้แบบ 16:00
    }
    return iso;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.Sale_Emp_Id)
      return Swal.fire("กรุณาเลือกฝ่ายขาย", "", "warning");
    if (!form.Time_Start)
      return Swal.fire("กรุณาระบุเวลาเริ่มต้น", "", "warning");
    if (!validateTimeOrder(form.Time_Start, form.Time_End))
      return Swal.fire("เวลาสิ้นสุดต้องมากกว่าเวลาเริ่มต้น", "", "warning");

    const resolvedServiceAddrId =
      form.ServiceAddr_Id || serviceAddrId || customerData?.ServiceAddr_Id;

    const currentGPS = form.Appoint_Id
      ? await getCurrentPosition().catch(() => null)
      : null;

    const payload = {
      Purpose: form.Purpose,
      Comp_Id: customerData?.Comp_Id || 1,
      AR_Id: customerData?.AR_Id || null,
      ServiceAddr_Id: resolvedServiceAddrId,
      Sale_Emp_Id: Number(form.Sale_Emp_Id),
      Appoint_Date: form.Appoint_Date,
      Appoint_Date: form.Appoint_Date,
      Time_Start: form.Time_Start,
      Time_End: form.Time_End,
      Remark: form.Remark?.trim() || "",
      Appoint_Id: form.Appoint_Id || null,
      Width: form.Width ? Number(form.Width) : null,
      Length: form.Length ? Number(form.Length) : null,
      Height: form.Height ? Number(form.Height) : null,
      SpecRemark: form.SpecRemark?.trim() || "",
      Latitude: currentGPS?.lat || null,
      Longitude: currentGPS?.lng || null,
    };

    const dup = await api.get("/check-appoint-duplicate", {
      params: {
        Sale_Emp_Id: form.Sale_Emp_Id,
        date: form.Appoint_Date,
        start: form.Time_Start,
        end: form.Time_End,
        ignoreId: form.Appoint_Id || null,
      },
    });

    if (dup.data.status === "OK" && dup.data.count > 0) {

      const html = dup.data.appoints
        .map((a) => {
          const start = formatTime(a.Time_Start);
          const end = formatTime(a.Time_End);

          return `
            <div style="
              background:#fff;
              border-radius:12px;
              padding:14px;
              margin-bottom:12px;
              box-shadow:0 0 6px rgba(0,0,0,0.07);
              border-left:6px solid #fff;
            ">
              <div style="font-size:15px;font-weight:bold;color:#E13F57;margin-bottom:6px;">
                ลูกค้า: ${a.AR_Name || ""} ${a.AR_LastName || ""}
              </div>
              <div style="font-size:14px;color:#555;">
                ผู้รับผิดชอบ: <b>${a.Emp_Name || "-"}</b>
              </div>
              <div style="font-size:14px;color:#555;">
                เวลา: <b>${start} - ${end}</b>
              </div>
            </div>
          `;
        })
        .join("");

      Swal.fire({
        title: "พบเวลานัดหมายซ้ำ!",
        html: `
          <div style="text-align:center;font-size:15px;margin-bottom:10px;">
            มีคิวในช่วงเวลาเดียวกัน
          </div>
          ${html}
        `,
        icon: "warning",
        width: 550,
        confirmButtonColor: "#E13F57",
        confirmButtonText: "ตกลง",
      });

      return;
    }

    try {
      const res = await onSave?.(form.Appoint_Id ? "edit" : "create", payload);

      if (res?.ServiceAddr_Id) {
        setForm((prev) => ({
          ...prev,
          ServiceAddr_Id: res.ServiceAddr_Id,
        }));
      }

      onClose();

    } catch (err) {
      Swal.fire("ผิดพลาด", "ไม่สามารถบันทึกข้อมูลได้", "error");
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-[2000] p-4">
      <div className="bg-white w-full max-w-2xl rounded-lg shadow-lg flex flex-col max-h-[90vh] relative">
        {/* Header - Sticky */}
        <div className="flex items-center justify-between border-b pb-2 mb-6 px-8 pt-8 flex-shrink-0">

          {/* ===== Left zone: Title + ฝ่ายขาย ===== */}
          <div className="flex items-end gap-4">

            {/* Title */}
            <h2 className="font-bold text-lg flex items-center gap-2 text-[#E13F57] border-b-2 border-[#E13F57] pb-1">
              <Icon icon="mdi:calendar" className="w-5 h-5" />
              {form.Appoint_Id ? "แก้ไขการนัดหมาย" : "สร้างนัดหมายใหม่"}
            </h2>

            {!form.Appoint_Id && (
              <div className="flex items-center gap-2">

                <span className="text-sm font-medium text-gray-700 whitespace-nowrap">
                  ฝ่ายขาย <span className="text-red-500">*</span>
                </span>

                <select
                  value={form.Sale_Emp_Id}
                  onChange={(e) => setForm({ ...form, Sale_Emp_Id: e.target.value })}
                  className="border rounded px-2 py-1 h-[36px] text-sm"
                  style={{ minWidth: "160px" }}
                >
                  <option value="">เลือกฝ่ายขาย</option>
                  {employees.map((emp) => (
                    <option key={emp.Emp_Id} value={emp.Emp_Id}>
                      {emp.Emp_Name}
                    </option>
                  ))}
                </select>
              </div>
            )}


          </div>

          {/* ===== Right zone: ปุ่มต่าง ๆ ===== */}
          <div className="flex items-center gap-3">

            {form.Appoint_Id && (
              <>
                <div className="relative inline-block">
                  <button
                    type="button"
                    onClick={() => setShowFileModal(true)}
                    className="bg-[#F17F25] hover:bg-[#d96f20] text-white px-3 py-1.5 rounded-lg flex items-center gap-1 shadow-sm"
                  >
                    <Icon icon="mdi:paperclip" className="w-5 h-5" />
                    แนบรูป
                  </button>

                  {selectedFiles.length > 0 && (
                    <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs font-bold px-[6px] py-[1px] rounded-full shadow-md">
                      {selectedFiles.length}
                    </span>
                  )}
                </div>

                <button
                  type="button"
                  onClick={() => setShowServiceModal(true)}
                  className="bg-[#F17F25] hover:bg-[#d96f20] text-white px-3 py-1.5 rounded-lg flex items-center gap-1 shadow-sm"
                >
                  <Icon icon="mdi:map-marker" className="w-5 h-5" />
                  ดูข้อมูลสถานที่บริการ
                </button>
              </>
            )}

            <button
              type="button"
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
            >
              ✕
            </button>

          </div>
        </div>

        {/* Scrollable Content */}
        <div className="overflow-y-auto overflow-x-hidden flex-1 px-8 pb-4">
        {!initialData?.Appoint_Id && !fromCustomerPage && (
          <div className="border rounded-lg p-4 bg-gray-50 mb-5 shadow-sm">
            <h3 className="text-sm font-semibold text-gray-600 mb-3 flex items-center gap-2">
              <Icon icon="mdi:account-box" className="w-5 h-5 text-[#E13F57]" />
              ข้อมูลลูกค้าที่จะนัดหมาย
            </h3>

            <div className="grid grid-cols-1 gap-3">

              {/* ชื่อลูกค้า (เต็มแถว) */}
              <div>
                <label className="block text-xs text-gray-500">ชื่อลูกค้า</label>
                <div className="font-medium text-gray-800 bg-white border rounded px-3 py-2">
                  {customerData?.customer?.AR_Name || "-"}{" "}
                  {customerData?.customer?.AR_LastName || ""}
                </div>
              </div>

              {/* ชื่อผู้ติดต่อ + เบอร์โทร อยู่ในแถวเดียวกัน 2 คอลัมน์ */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">

                <div>
                  <label className="block text-xs text-gray-500">ชื่อผู้ติดต่อ</label>
                  <div className="font-medium text-gray-800 bg-white border rounded px-3 py-2">
                    {customerData?.contact?.AR_ContactName || "-"}
                  </div>
                </div>

                <div>
                  <label className="block text-xs text-gray-500">เบอร์โทร</label>
                  <div className="font-medium text-gray-800 bg-white border rounded px-3 py-2">
                    {customerData?.contact?.AR_Tel || "-"}
                  </div>
                </div>

              </div>
            </div>
          </div>
        )}



        <form ref={formRef} onSubmit={handleSubmit} className="space-y-5">
          {!form.Appoint_Id && (
            <div className="col-span-4">
              <label className="block text-sm font-medium mb-1 text-gray-700">
                จุดประสงค์ <span className="text-red-500">*</span>
              </label>
              <div className="flex items-center gap-x-10 flex-wrap">
                <label className="flex items-center gap-3 whitespace-nowrap min-w-[170px]">
                  <input
                    type="radio"
                    name="purpose"
                    checked={form.Purpose === "followup"}
                    onChange={() => setForm({ ...form, Purpose: "followup" })}
                    className="accent-[#E13F57] w-4 h-4 flex-shrink-0"
                  />
                  <span className="leading-none">นัดหมายเพื่อโทรหา</span>
                </label>

                <label className="flex items-center gap-3 whitespace-nowrap min-w-[170px]">
                  <input
                    type="radio"
                    name="purpose"
                    checked={form.Purpose === "visit"}
                    onChange={() => {
                      setForm((prev) => ({ ...prev, Purpose: "visit" }));

                      // ถ้าไม่มีสถานที่บริการ ให้เปิด modal เลือกสถานที่
                      if (!form.ServiceAddr_Id) {
                        setShowAddrPicker(true);
                      }
                    }}

                    className="accent-[#E13F57] w-4 h-4 flex-shrink-0"
                  />
                  <span className="leading-none">นัดหมายเพื่อเข้าพบ</span>
                </label>

              </div>
            </div>
          )}

          {/* ========== แสดงข้อมูลสถานที่เมื่อเลือกแล้ว (เฉพาะ purpose = visit หรือเมื่อเปิดแก้ไข แต่ไม่แสดงเมื่อเปิดจาก EditCustomer) ========== */}
          {((form.Purpose === "visit" || form.Appoint_Id) && form.ServiceAddr_Id && serviceInfo && !(fromCustomerPage && form.Appoint_Id)) && (
            <div className="border rounded-lg p-4 bg-gray-50 shadow-sm mb-4">
              {/* Header */}
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-sm font-semibold text-gray-700 flex items-center gap-2">
                  <Icon icon="mdi:map-marker" className="w-5 h-5 text-[#E13F57]" />
                  สถานที่บริการที่เลือก
                </h3>

                {!form.Appoint_Id && (
                  <button
                    type="button"
                    onClick={() => setShowAddrPicker(true)}
                    className="bg-[#E13F57] hover:bg-[#c02f47] text-white px-4 py-2 rounded-lg text-sm"
                  >
                    เลือกสถานที่ใหม่
                  </button>
                )}
              </div>

              {/* วัตถุประสงค์ */}
              <div className="mb-3">
                <label className="block text-xs text-gray-500 mb-1">วัตถุประสงค์</label>
                <div className="w-full border bg-white rounded px-3 py-2 text-sm font-medium text-gray-700">
                  {purposeLabel(serviceInfo.ServicePurpose)}
                </div>
              </div>

              {/* ชื่อสถานที่บริการ — ลงมาข้างล่างเต็มแถว */}
              <div>
                <label className="block text-xs text-gray-500 mb-1">ชื่อสถานที่บริการ</label>
                <div className="w-full border bg-white rounded px-3 py-2 text-sm font-medium text-gray-700">
                  {serviceInfo.ServiceAddr_Name || "-"}
                </div>
              </div>
            </div>
          )}


          {!form.Appoint_Id && (
            <div className="grid grid-cols-1 md:grid-cols-12 gap-4">

              {/* วันที่นัดหมาย (4 col) */}
              <div className="md:col-span-4 relative">
                <label className="block text-sm font-medium mb-1 text-gray-700">
                  วันที่นัดหมาย <span className="text-red-500">*</span>
                </label>
                <div className="flex items-center">
                  <input
                    type="text"
                    value={formatToThaiDate(form.Appoint_Date)}
                    readOnly
                    className="w-full border rounded-l px-3 py-2 h-[42px] font-mono bg-white"
                  />
                  <button
                    type="button"
                    onClick={() => {
                      const dateInput = document.getElementById("hiddenDateInput");
                      if (dateInput.showPicker) dateInput.showPicker();
                      else dateInput.click();
                    }}
                    className="bg-[#E13F57] hover:bg-[#c02f47] text-white px-3 h-[42px] rounded-r flex items-center justify-center"
                  >
                    <Icon icon="mdi:calendar-month-outline" className="w-5 h-5" />
                  </button>
                </div>
                <input
                  type="date"
                  id="hiddenDateInput"
                  value={form.Appoint_Date}
                  onChange={(e) =>
                    setForm({ ...form, Appoint_Date: e.target.value })
                  }
                  className="absolute opacity-0 w-[1px] h-[1px]"
                  tabIndex={-1}
                />
              </div>

              {/* เวลาเริ่ม (4 col) */}
              <div className="md:col-span-4">
                <label className="block text-sm font-medium mb-1 text-gray-700">
                  เวลาเริ่มต้น <span className="text-red-500">*</span>
                </label>
                <TimePickerHybrid
                  value={form.Time_Start}
                  onChange={handleStartChange}
                />
              </div>

              {/* เวลาสิ้นสุด (4 col) */}
              <div className="md:col-span-4">
                <label className="block text-sm font-medium mb-1 text-gray-700">
                  เวลาสิ้นสุด
                </label>
                <TimePickerHybrid
                  value={form.Time_End}
                  onChange={(val) => setForm({ ...form, Time_End: val })}
                />
              </div>

            </div>
          )}


          {form.Appoint_Id && (
            <>
              <div>
                <label className="block text-sm font-medium mb-1 text-gray-700">
                  ขนาดพื้นที่
                </label>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-1">
                      กว้าง <span className="text-gray-500">(เมตร)</span>
                    </label>
                    <input
                      type="number"
                      name="Width"
                      value={form.Width || ""}
                      onChange={(e) => setForm({ ...form, Width: e.target.value })}
                      className="w-full border rounded px-3 py-2 h-[42px]"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-1">
                      ยาว <span className="text-gray-500">(เมตร)</span>
                    </label>
                    <input
                      type="number"
                      name="Length"
                      value={form.Length || ""}
                      onChange={(e) => setForm({ ...form, Length: e.target.value })}
                      className="w-full border rounded px-3 py-2 h-[42px]"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-1">
                      สูง <span className="text-gray-500">(ชั้น)</span>
                    </label>
                    <input
                      type="number"
                      name="Height"
                      value={form.Height || ""}
                      onChange={(e) => setForm({ ...form, Height: e.target.value })}
                      className="w-full border rounded px-3 py-2 h-[42px]"
                    />
                  </div>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1 text-gray-700 whitespace-nowrap">
                  ผลการนัดหมาย
                </label>
                <textarea
                  rows="2"
                  value={form.SpecRemark || ""}
                  onChange={(e) =>
                    setForm({ ...form, SpecRemark: e.target.value })
                  }
                  className="w-full border rounded px-3 py-2 focus:ring focus:ring-red-100 h-[80px]"
                  placeholder="สรุปผลการเข้าพบ"
                />
              </div>
            </>
          )}

          <div>
            <label className="block text-sm font-medium mb-1 text-gray-700 whitespace-nowrap">
              รายละเอียดเพิ่มเติม
            </label>
            <textarea
              rows="3"
              value={form.Remark || ""}
              onChange={(e) => setForm({ ...form, Remark: e.target.value })}
              className="w-full border rounded px-3 py-2 focus:ring focus:ring-red-100 h-[80px]"
            />
          </div>

          {userRole === "Admin" &&
            form.Appoint_Id &&
            checkinPos?.lat &&
            checkinPos?.lng && (
              <div className="border rounded-lg p-4 shadow-sm">
                <h3 className="text-base font-semibold text-gray-700 mb-3">
                  ตรวจสอบการเช็คอินพนักงาน
                </h3>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-3">
                  <div>
                    <label className="block text-sm font-medium mb-1">Latitude</label>
                    <input
                      type="text"
                      value={latlng?.lat || ""}
                      disabled
                      className="w-full border rounded px-3 py-2 h-[42px] bg-gray-100 cursor-not-allowed"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-1">Longitude</label>
                    <input
                      type="text"
                      value={latlng?.lng || ""}
                      disabled
                      className="w-full border rounded px-3 py-2 h-[42px] bg-gray-100 cursor-not-allowed"
                    />
                  </div>

                  {latlng?.lat &&
                    latlng?.lng &&
                    checkinPos?.lat &&
                    checkinPos?.lng && (() => {
                      const distance = getDistanceKm(
                        Number(latlng.lat),
                        Number(latlng.lng),
                        Number(checkinPos.lat),
                        Number(checkinPos.lng)
                      );
                      return (
                        <p className="text-sm mt-1 whitespace-nowrap">
                          ระยะห่างจากจุดเช็คอิน:{" "}
                          <span
                            className={`font-bold ${
                              distance > 1 ? "text-red-600" : "text-green-600"
                            }`}
                          >
                            {distance.toFixed(2)} km (
                            {distance > 1 ? "อยู่นอกพื้นที่บริการ" : "อยู่ในพื้นที่บริการ"})
                          </span>
                        </p>
                      );
                    })()}
                </div>

                <MapContainer
                  center={[Number(latlng.lat), Number(latlng.lng)]}
                  zoom={16}
                  style={{ height: "250px", width: "100%", zIndex: 1 }}
                  scrollWheelZoom={true}
                  dragging={true}
                  doubleClickZoom={true}
                >
                  <TileLayer
                    url="https://mt1.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}"
                    attribution="© Google Maps Satellite"
                  />

                  <CircleMarker
                    center={[Number(latlng.lat), Number(latlng.lng)]}
                    radius={10}
                    pathOptions={{
                      color: "#2563eb",
                      fillColor: "#2563eb",
                      fillOpacity: 0.85
                    }}
                  />

                  <CircleMarker
                    center={[Number(checkinPos.lat), Number(checkinPos.lng)]}
                    radius={10}
                    pathOptions={{
                      color: "#16a34a",
                      fillColor: "#16a34a",
                      fillOpacity: 0.85
                    }}
                  >
                    <Popup>ตำแหน่งเช็คอินพนักงาน</Popup>
                  </CircleMarker>

                  <Polyline
                    positions={[
                      [Number(latlng.lat), Number(latlng.lng)],
                      [Number(checkinPos.lat), Number(checkinPos.lng)]
                    ]}
                    pathOptions={{ color: "#2563eb", weight: 3 }}
                  />

                  <MapUpdater lat={latlng.lat} lng={latlng.lng} />
                </MapContainer>
              </div>
          )}
        </form>
        </div>

        {/* Footer - Sticky */}
        <div className="border-t px-8 py-4 flex justify-end items-center gap-3 flex-shrink-0 bg-white rounded-b-lg">
          <button
            type="button"
            onClick={() => {
              setForm({
                Purpose: "followup",
                Sale_Emp_Id: "",
                Appoint_Date: new Date().toISOString().split("T")[0],
                Time_Start: "",
                Time_End: "",
                Remark: "",
                Width: "",
                Length: "",
                Height: "",
                SpecRemark: "",
                Appoint_Id: null,
              });
              onClose();
            }}
            className="border border-[#E13F57] text-[#E13F57] px-6 py-2 rounded-lg hover:bg-[#ffe8eb]"
          >
            ยกเลิก
          </button>
          <button
            type="button"
            onClick={() => {
              if (formRef.current) {
                formRef.current.requestSubmit();
              }
            }}
            className="bg-[#E13F57] hover:bg-[#c02f47] text-white px-6 py-2 rounded-lg"
          >
            {form.Appoint_Id ? "อัปเดต" : "บันทึก"}
          </button>
        </div>
      </div>

      {showFileModal && (
        <FileModalLocation
          mode="E"
          showViewAttachModal={showFileModal}
          setShowViewAttachModal={setShowFileModal}
          selectedFiles={selectedFiles}
          setSelectedFiles={setSelectedFiles}
          Appoint_Id={form.Appoint_Id}
          ServiceAddr_Id={form.ServiceAddr_Id || serviceAddrId}
        />
      )}

      {showServiceModal && (
        <ServiceLocationModal
          isOpen={showServiceModal}
          onClose={() => setShowServiceModal(false)}
          ServiceAddr_Id={form.ServiceAddr_Id || initialData?.ServiceAddr_Id || serviceAddrId}
          onSave={handleSaveServiceLocation}
          viewMode="appointment"
          serviceTypes={serviceTypes}
        />
      )}
      
      {showAddrPicker && (
        <LocationModal
          isOpen={showAddrPicker}
          onClose={() => setShowAddrPicker(false)}
          arId={customerData?.AR_Id}
          onSelect={(loc) => {
            setForm((prev) => ({
              ...prev,
              ServiceAddr_Id: loc.ServiceAddr_Id,
            }));
            setShowAddrPicker(false);
          }}
        />
      )}


    </div>
  );
}
